import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/SalesAttributionDrilldownChart';
import { renderTitle } from './getSalesAttributionColumns';
import { formatNumWithKMB, formatNumWithKMBAlt } from './helperMethods';
import _ from 'lodash';

//price ladder table columns
export const getPriceLadderTableColumns = (
    data: any,
    width: number,
    decimalForNonPercentage: number,
    decimalForPercentage: number,
): any => {
    let result = [];
    const keys = data && data.length > 0 ? Object.keys(data?.[0]) : [];
    const columns =
        data && data.length > 0
            ? keys.map((item: any, index: number) => {
                  return {
                      title:
                          index === 0
                              ? ''
                              : renderTitle(
                                    item,
                                    undefined,
                                    undefined,
                                    'text-purpleFont !font-bold',
                                    graphXAxisLabelFontSize,
                                ),
                      //title: index > 1 ? renderTitle(item) : '',
                      dataIndex: item,
                      key: item,
                      align: index === 0 ? 'left' : 'center',
                      fixed: index === 0 ? 'left' : null,
                      width: index === 0 ? 150 : width,
                      render: (columnData: any, rowData: any, index: number) => {
                          return (
                              <div>
                                  {_.isNull(columnData)
                                      ? ''
                                      : typeof columnData === 'string'
                                      ? columnData
                                      : columnData?.pre +
                                        formatNumWithKMBAlt(
                                            columnData?.value,
                                            columnData?.post === '%' ? decimalForPercentage : decimalForNonPercentage,
                                            columnData?.post === '%' ? undefined : decimalForNonPercentage,
                                        ) +
                                        columnData?.post}
                              </div>
                          );
                      },
                      //   render:(columnData:any,rowData:any) =>{
                      //     return (

                      //     )
                      //   }
                  };
              })
            : [];

    result = [...columns];
    return result;
};
